import SignUpComponent from "@components/SignUpComponent/SignUpComponent";
import styles from "./SignUpPage.module.css"

const SignUpPage = () => {
    return ( <div className={styles.Wrapper}>
        <SignUpComponent/>
    </div> );
}
 
export default SignUpPage;